import type { UseFetchOptions } from 'nuxt/app'

export const useApi = <T> (
  url: string | (() => string),
  options: UseFetchOptions<T> = {},
) => {
  return useFetch(url, {
    ...options,
    $fetch: useNuxtApp().$api,
    transform: (result: ApiSuccessResponse<T>): T => {
      return result.data
    },
  })
}

export const useBOFApi = <T> (
  url: string | (() => string),
  options: UseFetchOptions<T> = {},
) => {
  return useFetch(url, {
    ...options,
    $fetch: useNuxtApp().$apiBOF,
    transform: (result: ApiSuccessResponse<T>): T => {
      return result.data
    },
  })
}
